module.exports = __webpack_public_path__ + "img/demande.2c6840c0.png";